// NX-3941: pure formatter/parser helpers for NumericInput (the engine behind
// AppCurrencyInput/AppPercentageInput/AppRateInput). Kept React-free so
// they can be unit-tested in isolation.

// Strip currency symbols (£/$/€), thousand separators and spaces from the
// typed/pasted text. Same rule as `toNumber`; antd then coerces to a number.
// (We intentionally do NOT use the strict `parseFormattedNumber` here — it
// rejects in-progress input like "-" or "10." and would block typing.)
export const stripFormatting = (displayValue?: string): string =>
  (displayValue ?? '').replace(/[£$€,\s]/g, '').replace(/^\+/, '');

const addThousands = (intDigits: string): string =>
  intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

// Add thousand separators for display. While the user is typing we echo their
// raw text (so the decimal point and trailing zeros survive); on blur/commit we
// pad to a minimum of 2 decimals (money convention) WITHOUT rounding — values
// that already carry more precision (e.g. a 10.556 rate) are kept as-is.
export const formatThousands = (
  value?: string | number,
  info?: { userTyping: boolean; input: string },
): string => {
  if (value === undefined || value === null || value === '') {
    return '';
  }
  const source = info?.userTyping && info.input != null ? info.input : String(value);
  const negative = source.trim().startsWith('-');
  const digitsDot = source.replace(/[^\d.]/g, '');
  const dotIndex = digitsDot.indexOf('.');
  const intDigits = dotIndex === -1 ? digitsDot : digitsDot.slice(0, dotIndex);
  let decimals = dotIndex === -1 ? '' : digitsDot.slice(dotIndex + 1).replace(/\./g, '');
  const sign = negative ? '-' : '';
  const separated = addThousands(intDigits);

  if (info?.userTyping) {
    return dotIndex === -1 ? `${sign}${separated}` : `${sign}${separated}.${decimals}`;
  }
  if (decimals.length < 2) {
    decimals = decimals.padEnd(2, '0');
  }
  return `${sign}${separated}.${decimals}`;
};
